var testmair = {"id":5,"first_name":"محمد","last_name":"احمد","cin":"12457010","date_of_birth":"1987-01-01T00:00:00.000000Z","address":"مرسى","cin_date":"2019-07-01T00:00:00.000000Z"};
module.exports =()=>{

    return testmair
}